import environment from 'environment';
import { handleError } from 'services/ErrorService/ErrorService';
import makeRequest from './makeRequest';
import makeCloudFunctionRequest from './makeCloudFunctionRequest';

export const getBusinessDetailsItem = async (simplrAccountId) => {
  const url = `${environment.app.serverApiUrl}/v1/expert-portal/get-business-details-item`;

  return await makeRequest(url, { params: { simplrAccountId } });
};

// TODO: remove when escalation messages are consolidated in BusinessDetails
export const getDefaultEscalationMessage = async ({ simplrAccountPtrId, conversationId }) => {
  try {
    return await makeCloudFunctionRequest('getDefaultEscalationMessage', {
      simplrAccountPtrId,
      conversationId,
    });
  } catch (error) {
    handleError({ error });

    return {
      outboundEscalationMessage: '',
    };
  }
};

export * from './partnerQueries';
